import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { colCenter } from "../../style/style";
import { LanguageMenu, SwitchLanguage } from "@ui/components/language";
import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { ArrowDown2, HambergerMenu, Logout } from "iconsax-react";
import { HMenu } from "@ui/components/menu/HMenu";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import LocalStorageService from "@application/features/Common/local-storage-service";
import { useMsal } from "@azure/msal-react";
import { clearEventState } from "@application/features/Event/EventSlice";
import { persistor } from "@application/store";
import { PIconButton } from "@ui/components/buttons/PIconButton";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import GlobalSearch from "../globalSearch";
import useSwitchLanguage from "@ui/components/language/useSwitchLanguage";
import { getLanguageDisplay, Language } from "@ui/components/language/languageUtils";
const navLinks = [
    { title: "header.invitations", path: "/admin/invitation" },
    // { title: "Users", path: "/admin/users" },
    // { title: "Companies", path: "/admin/companies" },
];
const roundedHeaderPages = ["/admin/empty-invitations"];
export const AdminHeader = ({ toggleSearch, isSearchExpanded, }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { instance } = useMsal();
    const isBelow1200 = useMediaQuery(theme.breakpoints.down(1201));
    const isBetween600And650 = useMediaQuery(theme.breakpoints.between(600, 651));
    const isLargeScreen = useMediaQuery("(min-width:900px)");
    const [anchorEl, setAnchorEl] = useState(null);
    const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
    const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(Language.NL);
    const handleLanguageMenuOpen = (event) => {
        setIsLanguageMenuOpen(true);
        setLanguageAnchorEl(event.currentTarget);
    };
    const handleLanguageMenuClose = () => {
        setIsLanguageMenuOpen(false);
        setLanguageAnchorEl(null);
    };
    const { languages, renderFlagIcon } = useSwitchLanguage({
        handleMenuClose: handleLanguageMenuClose,
        selectedLanguage,
        setSelectedLanguage,
    });
    const boxBottomRef = useRef(null);
    const searchButtonRef = useRef(null);
    const open = Boolean(anchorEl);
    const { currentUser } = useAppSelector((state) => state.auth);
    const logout = () => {
        dispatch(clearEventState());
        persistor.purge();
        const currentAccount = instance.getActiveAccount();
        instance.logoutRedirect({
            account: currentAccount,
            postLogoutRedirectUri: "/",
            onRedirectNavigate: () => {
                LocalStorageService.removeMSAccessToken();
                LocalStorageService.removeAccessToken();
                LocalStorageService.removeRefreshToken();
                return true;
            },
        });
    };
    useEffect(() => {
        if (!isSearchExpanded)
            return;
        const handleClickOutside = (event) => {
            const target = event.target;
            if (boxBottomRef.current &&
                !boxBottomRef.current.contains(target) &&
                searchButtonRef.current &&
                !searchButtonRef.current.contains(target)) {
                toggleSearch();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isSearchExpanded, toggleSearch]);
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const isMobileScreen = useMediaQuery("(max-width:650px)");
    const isRounded = roundedHeaderPages.includes(location.pathname);
    const menuItems = [
        {
            label: getLanguageDisplay(selectedLanguage, isLargeScreen),
            icon: renderFlagIcon(selectedLanguage),
            endIcon: _jsx(ArrowDown2, { size: "12px" }),
            onClick: (e) => {
                if (isLanguageMenuOpen) {
                    handleLanguageMenuClose();
                }
                else {
                    handleLanguageMenuOpen(e);
                }
            },
            subMenu: (_jsx(LanguageMenu, { anchorEl: languageAnchorEl, isOpen: isLanguageMenuOpen, languages: languages, onClose: handleLanguageMenuClose })),
            isVisible: isSmallScreen,
        },
        {
            label: t("header.logout"),
            icon: _jsx(Logout, { size: 20 }),
            isVisible: true,
            onClick: () => {
                handleClose();
                logout();
            },
        },
    ];
    return (_jsx(Box, { className: "admin-navigation", sx: {
            height: "auto",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            paddingTop: "8px",
            paddingLeft: { xs: 1, sm: 3 },
            paddingRight: { xs: 1, sm: 3 },
            borderRadius: "0 0 24px 24px",
            transition: "all 0.2s ease-in-out",
            zIndex: 22,
            background: (theme) => isSearchExpanded ? theme.palette.background.paper : "transparent",
            boxShadow: isSearchExpanded ? "0 4px #00244d0a" : "none",
        }, children: _jsxs(Box, { className: "navigation-content", sx: {
                width: "100%",
                background: (theme) => theme.palette.background.paper,
                borderRadius: "24px",
            }, children: [_jsxs(Box, { className: "box-top", sx: {
                        boxShadow: isSearchExpanded ? "" : "0px 0px 2px 0px #919EAB33",
                        background: (theme) => theme.palette.background.paper,
                        width: "100%",
                        borderTopLeftRadius: "24px",
                        borderTopRightRadius: "24px",
                        borderBottomLeftRadius: isRounded ? "24px" : 0,
                        borderBottomRightRadius: isRounded ? "24px" : 0,
                        border: isSearchExpanded ? "none" : "inherit",
                        borderRadius: isSearchExpanded ? "24px" : "",
                        py: 1,
                        px: { xs: 1, sm: 2, md: 3 },
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                    }, children: [_jsxs(Box, { sx: { ...colCenter, gap: { xs: 1, sm: 2, md: 3 } }, children: [_jsx("img", { src: "/assets/images/logo.svg", width: isSmallScreen ? 70 : 102, height: isSmallScreen ? 40 : 57.91, alt: "Logo" }), _jsx(Box, { sx: { ...colCenter, gap: 1 }, children: navLinks.map(({ title, path }) => (_jsx(Button, { component: NavLink, to: path, color: "inherit", variant: location.pathname === path ? "contained" : "soft", children: t(title) }, path))) })] }), !isBelow1200 && _jsx(GlobalSearch, {}), _jsxs(Box, { sx: { ...colCenter, gap: 1.5 }, children: [isBelow1200 && (_jsx(PIconButton, { buttonRef: searchButtonRef, size: isBetween600And650
                                        ? "large"
                                        : isMobileScreen
                                            ? "medium"
                                            : "large", color: "#637381", onClick: toggleSearch, children: _jsx(Icon, { icon: `eva:${isSearchExpanded ? "close-fill" : "search-fill"}`, width: "24", height: "24", color: theme.palette.text.disabled }) })), !isSmallScreen && (_jsx(SwitchLanguage, { selectedLanguage: selectedLanguage, setSelectedLanguage: setSelectedLanguage, buttonProps: {
                                        sx: { borderRadius: { xs: 1, md: 2 }, fontWeight: 500 },
                                        variant: "soft",
                                        color: "primary",
                                        size: "large",
                                    } })), isMobileScreen ? (_jsx(PIconButton, { size: isBetween600And650 ? "large" : "medium", onClick: handleOpen, color: "#637381", children: _jsx(HambergerMenu, {}) })) : (_jsx(Button, { onClick: handleOpen, variant: "soft", size: "large", color: "inherit", 
                                    // startIcon={<HAvatar name={`${currentUser?.name}`} imageSrc="" />}
                                    endIcon: _jsx(ArrowDown2, {}), children: currentUser?.name })), _jsx(HMenu, { right: isMobileScreen ? "10px" : "50%", anchorEl: anchorEl, open: open, handleClose: handleClose, menuItems: menuItems })] })] }), _jsx(Box, { className: "box-bottom", ref: boxBottomRef, sx: {
                        display: isSearchExpanded ? "block" : "none",
                        height: isSearchExpanded ? "auto" : 0,
                        overflow: "hidden",
                        width: "100%",
                        transition: "all .2s ease-in-out",
                        mt: 2,
                    }, children: _jsx(GlobalSearch, { fullWidth: true, bordered: false }) })] }) }));
};
